import { useAtom } from 'jotai';
import { apartmentOnTopState, currentApartmentAtom, isMobile } from '../states/planner';
import crossURL from '../assets/cross.svg';
import { storageUrl } from '../firebase';
import ZoomableImage from './ZoomableImage';
import useSite from '../hooks/useSite';
import { StatusBanner } from './StatusBanner';

export const ApartmentView = () => {
  const [site] = useSite();
  const [apartment, setCurrentApartment] = useAtom(currentApartmentAtom);
  const [, setApartmentOnTop] = useAtom(apartmentOnTopState);

  if (!apartment) return null;

  const apartmentPictures = apartment.pictures || [];
  const pictures = [apartment.floorplanpicture, ...apartmentPictures];
  const haveButtons = apartment.interesturl || apartment.sheeturl || apartment.producturl;

  return (
    <div part="view-border" className="view-border absolute left-0 top-0 z-1 h-full w-full align-middle">
      <div className="absolute bottom-1 left-1 right-1 top-1 bg-white">
        <button
          onClick={() => {
            setApartmentOnTop(null);
            setCurrentApartment(null);
          }}
          className="absolute right-0 top-0 z-2 m-3"
        >
          <img src={crossURL} alt="close" className="" />
        </button>
        <div className="relative flex h-full w-full flex-col">
          <div className="singleapartmentpicture relative flex flex-grow items-start justify-center">
            <ZoomableImage
              src={storageUrl(pictures[0])}
              moveDown={!haveButtons}
              moveRight={!site.hideapartmentinfo}
              alt="apartmentpicture"
            />
          </div>

          <div className="flex h-0 items-center justify-center">
            <ul className="flex justify-center gap-10 max-[400px]:gap-2 sm:gap-24">
              {apartment.interesturl && (
                <li>
                  <a href={apartment.interesturl} target="_top" rel="noopener noreferrer">
                    <button
                      part="apartment-button"
                      className="apartment-button interest-button h-8 w-44 -translate-y-12 hover:opacity-90 max-[400px]:w-36 max-[400px]:-translate-y-8 sm:h-11 sm:w-52 sm:-translate-y-16 sm:text-sm"
                    >
                      Intresseanmälan
                    </button>
                  </a>
                </li>
              )}

              {apartment.sheeturl && (
                <li>
                  <a href={apartment.sheeturl} target="_blank" rel="noopener noreferrer">
                    <button
                      part="apartment-button"
                      className="apartment-button info-button h-8 w-44 -translate-y-12 hover:opacity-90 max-[400px]:w-36 max-[400px]:-translate-y-8 sm:h-11 sm:w-52 sm:-translate-y-16 sm:text-sm"
                    >
                      Bofaktablad
                    </button>
                  </a>
                </li>
              )}
            </ul>
          </div>

          {site.hideapartmentinfo ? null : (
            <div className="pointer-events-none absolute left-0 top-2 z-2 flex flex-col items-start sm:top-4">
              <StatusBanner status={apartment.status} className="-ml-1 pl-4 pr-3 sm:pl-7 sm:pr-4" />

              <div className="ml-2 mt-2 flex flex-col items-start sm:ml-4">
                <div className="rounded-r-xl bg-white/80 px-2 pt-2">
                  <div className="text-lg font-black leading-none sm:text-[24px]">
                    {apartment.rok} rok, {apartment.size} m²
                  </div>
                </div>

                <div className="rounded-br-xl bg-white/80 px-2 py-2 pb-2">
                  <div className="text-[14px] font-medium leading-none">Nr. {apartment.apartmentid}</div>
                </div>
              </div>
            </div>
          )}
          {apartment.producturl && (
            <a
              href={apartment.producturl}
              target="_top"
              className="product-button absolute bottom-5 right-5 flex h-[54px] items-center justify-center bg-white px-[35px] text-sm sm:h-[58px] sm:text-base"
            >
              Läs mer
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
